import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';

import {Renderer} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {useLinkNavigation} from '../../../components/common/navigation/useLinkNavigation';
import {SettingsCustomFieldsPagesEnum} from '../../../models/url/settingsUrlModel';
import {SettingsBreadcrumbs} from '../../common/settingsBreadcrumbs';
import {SettingsHeader} from '../../settingsHeader';
import {getCustomFieldsBaseUrl} from '../customFieldsHelpers';

/*
 * Types.
 */

interface CustomFieldBreadcrumbProps {
  tabPage: SettingsCustomFieldsPagesEnum;
  title: ReactNode;
  renderActions?: Renderer;
}

/*
 * Component.
 */

export const CustomFieldBreadcrumb: FC<CustomFieldBreadcrumbProps> = ({tabPage, title, renderActions}) => {
  const {navigateToLink} = useLinkNavigation();

  const renderTopLine = () => (
    <SettingsBreadcrumbs
      showSeparatorAfterTopLevel
      topLevelBreadcrumb={{
        label: <Trans id="settings-custom-fields-breadcrumb">Custom fields</Trans>,
        onBreadcrumbClick: () => navigateToLink(`${getCustomFieldsBaseUrl(tabPage)}/overview`),
      }}
      breadcrumbs={[]}
    />
  );
  return (
    <SettingsHeader tabs={null} topLine={renderTopLine()} right={renderActions ? renderActions() : undefined}>
      {title}
    </SettingsHeader>
  );
};
